import React, { Component } from 'react';
import { Form, Button, Card, CardBody } from 'reactstrap';
import { InputQuestionCurrency, InputQuestionNumber, InputQuestionSelect, InputQuestionSelectOption } from '../../../components/Inputs/InputQuestions';
import { connect } from 'react-redux';
import { updateTaxInput, nextWizardStep, mortgageCalcShow } from '../TaxActions'
import { propertyToTax } from '../../PropertyCalculator/PropertyActions'

class Wizard extends Component {
    displayName = Wizard.name

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);       
    }

    handleInputChange(event) {
        // Extract the name of the input and it's value from the DOM event
        const target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        value = value == 'true' ? true : value;
        value = value == 'false' ? false : value;
        const name = target.name;

        this.props.updateTaxInput(name, value);
    }

    render() {
        const values = this.props;
        const wizardStep = this.props.wizardStep;

        return (
            <Card>
                <CardBody>
                    <Form>
                        {wizardStep >= 1 &&
                            <React.Fragment>
                                <h4>Your goals</h4>
                                <InputQuestionSelect name="goal" value={values.goal} title="Your property goal" onChange={this.handleInputChange}>
                                    <InputQuestionSelectOption name="Buy another property after this one" value='nextProperty' />
                                    <InputQuestionSelectOption name="Save the profits and build a nest-egg" value='retain' />
                                    <InputQuestionSelectOption name="Generate a regular income" value='income' />
                                </InputQuestionSelect>

                                {
                                    values.goal == 'nextProperty' &&
                                    <React.Fragment>
                                        <InputQuestionCurrency name="profitGoal" value={values.profitGoal} title="How much do you need to buy your next property?" onChange={this.handleInputChange} />
                                        <InputQuestionCurrency name="additionalAnnualInvestment" value={values.additionalAnnualInvestment} title="How much of your own savings will you contribute each year?" onChange={this.handleInputChange} />
                                    </React.Fragment>
                                }

                                {
                                    values.goal == 'retain' &&
                                    <InputQuestionSelect name="projectionYears" value={values.projectionYears} title="How long do you want to save for?" onChange={this.handleInputChange}>
                                        <InputQuestionSelectOption name="5 years" value='5' />
                                        <InputQuestionSelectOption name="10 years" value='10' />
                                        <InputQuestionSelectOption name="15 years" value='15' />
                                        <InputQuestionSelectOption name="25 years" value='25' />
                                    </InputQuestionSelect>
                                }

                                {wizardStep == 1 &&
                                    <Button className="float-right" style={{ marginRight: '0' }} color="primary" size="sm" onClick={this.props.nextWizardStep}>Next</Button>
                                }
                                <hr style={{ clear: 'both' }} />
                            </React.Fragment>
                        }

                        {wizardStep >= 2 &&
                            <React.Fragment>
                            <h4>Your property</h4>                            
                                <Button outline color="primary" size="sm" onClick={this.props.propertyToTax} > Copy from property calculator</Button>
                                <InputQuestionCurrency name="propertyIncome" value={values.propertyIncome} title="Total rental income, per year" onChange={this.handleInputChange} />
                                <InputQuestionCurrency name="propertyAllowableExpenses" value={values.propertyAllowableExpenses} title="Allowable expenses, per year" onChange={this.handleInputChange} />
                                <InputQuestionCurrency name="propertyFinanceCosts" value={values.propertyFinanceCosts} title="Finance costs, per year" onChange={this.handleInputChange} />
                                <Button outline color="primary" size="sm" onClick={this.props.mortgageCalcShow} > Mortgage calculator</Button>

                                {wizardStep == 2 &&
                                    <Button className="float-right" style={{ marginRight: '0' }} color="primary" size="sm" onClick={this.props.nextWizardStep}>Next</Button>
                                }
                                <hr style={{ clear: 'both' }} />
                            </React.Fragment>
                        }

                        {wizardStep >= 3 &&
                            <React.Fragment>
                                <h4>Your other income</h4>
                                <InputQuestionCurrency name="nonPropertyEarnings" value={values.nonPropertyEarnings} title="Your gross income / earnings, per year" onChange={this.handleInputChange} />
                                <InputQuestionCurrency name="nonPropertyDividendIncome" value={values.nonPropertyDividendIncome} title="Your income from dividends, per year" onChange={this.handleInputChange} />

                                {wizardStep == 3 &&
                                    <Button className="float-right" style={{ marginRight: '0' }} color="success" size="sm" onClick={this.props.nextWizardStep}>Calculate</Button>
                                }

                            </React.Fragment>
                        }

                    </Form>
                </CardBody>
            </Card>
        );
    }
}


const mapStateToProps = state => {
    return state.tax;
};

export default connect(
    mapStateToProps,
    { updateTaxInput, nextWizardStep, mortgageCalcShow, propertyToTax }
)(Wizard)


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/Components/Wizard.jsx